import React, { useMemo } from "react";

export default function Stars({ className = "" } = {}) {
  const stars = useMemo(
    () => [
      { left: "8%", top: "10%", size: 26, glyph: "⭐", twinkle: 2.8, spin: 26, delay: -0.4 },
      { left: "18%", top: "26%", size: 18, glyph: "✦", twinkle: 3.6, spin: 34, delay: -1.2 },
      { left: "28%", top: "12%", size: 20, glyph: "★", twinkle: 3.2, spin: 29, delay: -0.8 },
      { left: "38%", top: "30%", size: 16, glyph: "✧", twinkle: 4.1, spin: 36, delay: -2.0 },
      { left: "46%", top: "16%", size: 22, glyph: "⭐", twinkle: 3.0, spin: 31, delay: -1.6 },
      { left: "56%", top: "8%", size: 17, glyph: "✦", twinkle: 3.8, spin: 33, delay: -0.2 },
      { left: "66%", top: "22%", size: 21, glyph: "★", twinkle: 3.4, spin: 28, delay: -1.0 },
      { left: "76%", top: "12%", size: 15, glyph: "✧", twinkle: 4.4, spin: 38, delay: -2.6 },
      { left: "86%", top: "26%", size: 24, glyph: "⭐", twinkle: 3.1, spin: 27, delay: -0.9 },
      { left: "12%", top: "44%", size: 14, glyph: "✦", twinkle: 4.6, spin: 40, delay: -3.1 },
      { left: "34%", top: "52%", size: 15, glyph: "✧", twinkle: 4.2, spin: 42, delay: -1.9 },
      { left: "58%", top: "46%", size: 14, glyph: "✦", twinkle: 4.7, spin: 41, delay: -2.9 },
      { left: "74%", top: "54%", size: 16, glyph: "★", twinkle: 4.0, spin: 37, delay: -2.2 },
      { left: "92%", top: "44%", size: 14, glyph: "✧", twinkle: 4.5, spin: 43, delay: -1.4 },
    ],
    []
  );

  return (
    <div className={`scene-stars ${className}`} aria-hidden="true">
      {stars.map((s, idx) => (
        <span
          key={idx}
          className="scene-stars__star"
          style={{
            "--ss-left": s.left,
            "--ss-top": s.top,
            "--ss-size": `${s.size}px`,
            "--ss-twinkle": `${s.twinkle}s`,
            "--ss-spin": `${s.spin}s`,
            "--ss-delay": `${s.delay}s`,
          }}
        >
          <span className="scene-stars__glyph">{s.glyph}</span>
        </span>
      ))}
    </div>
  );
}

